import { Github, Linkedin, Mail } from 'lucide-react';

export default function Hero() {
  return (
    <div className="flex flex-col items-start gap-4">
      <h1 className="text-4xl font-bold tracking-tight text-zinc-100 sm:text-5xl">
        <a href="/">Jia De (Arthur) Pang</a>
      </h1>
      <h2 className="text-lg font-medium tracking-tight text-zinc-200 sm:text-xl">
        Aspiring Cloud Solution Architect
      </h2>
      <p className="mt-4 max-w-xs leading-relaxed text-zinc-400">
        Crafting scalable architectures and innovative cloud solutions for tomorrow's challenges.
      </p>

      {/* Social Links */}
      <ul className="mt-8 flex items-center gap-6" aria-label="Social media">
        <li>
          <a
            href="https://github.com/Auswahlenn"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-zinc-400 hover:text-zinc-100 transition-colors"
          >
            <span className="sr-only">GitHub</span>
            <Github className="h-6 w-6" />
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/arthurpangjiade/"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-zinc-400 hover:text-zinc-100 transition-colors"
          >
            <span className="sr-only">LinkedIn</span>
            <Linkedin className="h-6 w-6" />
          </a>
        </li>
        <li>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="block text-zinc-400 hover:text-zinc-100 transition-colors"
          >
            <span className="sr-only">Email</span>
            <Mail className="h-6 w-6" />
          </a>
        </li>
      </ul>
    </div>
  );
}